import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication
} from '@azure/msal-browser';
import {MsalGuardConfiguration} from '@azure/msal-angular';
import {environment} from '../environments/environment';

export const scopes = [
  'openid',
  'profile',
  'User.Read',
];

export const loginRequest = {
  extraQueryParameters: {
    domain_hint: 'fedex.com',
  },
  scopes,
  extraScopesToConsent: ['offline_access']
};

export const loggerCallback = (logLevel: LogLevel, message: string) => {
  console.log(message);
};


export const MSALGuardConfigFactory = (): MsalGuardConfiguration => ({
  interactionType: InteractionType.Redirect,
  authRequest: loginRequest,
  loginFailedRoute: '/login-failed'
});


export const MSALInstanceFactory = (): IPublicClientApplication => {
  return new PublicClientApplication({
    auth: {
      authority: 'https://login.microsoftonline.com/myfedex.onmicrosoft.com',
      clientId: environment.azureClientID,
      redirectUri: environment.redirectUri,
      postLogoutRedirectUri: environment.postLogoutRedirectUri,
      navigateToLoginRequestUrl: true,
      // eslint-disable-next-line max-len
      authorityMetadata: '{"token_endpoint":"https://login.microsoftonline.com/b945c813-dce6-41f8-8457-5a12c2fe15bf/oauth2/v2.0/token","token_endpoint_auth_methods_supported":["client_secret_post","private_key_jwt","client_secret_basic"],"jwks_uri":"https://login.microsoftonline.com/b945c813-dce6-41f8-8457-5a12c2fe15bf/discovery/v2.0/keys","response_modes_supported":["query","fragment","form_post"],"subject_types_supported":["pairwise"],"id_token_signing_alg_values_supported":["RS256"],"response_types_supported":["code","id_token","code id_token","id_token token"],"scopes_supported":["openid","profile","email","offline_access"],"issuer":"https://login.microsoftonline.com/b945c813-dce6-41f8-8457-5a12c2fe15bf/v2.0","request_uri_parameter_supported":false,"userinfo_endpoint":"https://graph.microsoft.com/oidc/userinfo","authorization_endpoint":"https://login.microsoftonline.com/b945c813-dce6-41f8-8457-5a12c2fe15bf/oauth2/v2.0/authorize","device_authorization_endpoint":"https://login.microsoftonline.com/b945c813-dce6-41f8-8457-5a12c2fe15bf/oauth2/v2.0/devicecode","http_logout_supported":true,"frontchannel_logout_supported":true,"end_session_endpoint":"https://login.microsoftonline.com/b945c813-dce6-41f8-8457-5a12c2fe15bf/oauth2/v2.0/logout","claims_supported":["sub","iss","cloud_instance_name","cloud_instance_host_name","cloud_graph_host_name","msgraph_host","aud","exp","iat","auth_time","acr","nonce","preferred_username","name","tid","ver","at_hash","c_hash","email"],"kerberos_endpoint":"https://login.microsoftonline.com/b945c813-dce6-41f8-8457-5a12c2fe15bf/kerberos","tenant_region_scope":"NA","cloud_instance_name":"microsoftonline.com","cloud_graph_host_name":"graph.windows.net","msgraph_host":"graph.microsoft.com","rbac_url":"https://pas.windows.net"}'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: environment.msal.logLevel,
        piiLoggingEnabled: environment.msal.piiLogging
      }
    }
  });
};
